import React from "react";
import { Outlet } from "react-router-dom";
import { CartProvider } from "./context/CartContext";

export default function ShopCustomerLayout() {
  return (
    <div className="otaPageBg min-h-screen">
      <div className="max-w-[480px] mx-auto min-h-screen bg-white relative shadow-sm">
        <CartProvider>
          <Outlet />
        </CartProvider>
      </div>
    </div>
  );
}
